document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".full-formalities__wrapper");
  const loader = document.querySelector(".full-formalities__loader");
  const searchInput = document.getElementById("search-formalities");
  const userSelect = document.getElementById("type-user");
  const typeSelect = document.getElementById("tipe-formalitie");
  const paginationWrapper = document.getElementById("ajax-pagination");

  let searchTimeout = null;
  let currentPage = 1;
  triggerFilter();
  function showLoader(show = true) {
    if (loader) loader.style.display = show ? "block" : "none";
  }
  function createNoResultsContainer() {
    const container = document.createElement("div");
    container.className = "full-formalities__no-results";
    container.innerHTML = `<div class="full-formalities__no-results-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 8V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div><h3 class="full-formalities__no-results-title">No se encontraron resultados</h3><p class="full-formalities__no-results-message">Intenta ajustando tus filtros de búsqueda</p>`;
    container.style.display = "none";
    return container;
  }
  function triggerFilter(page = 1) {
    if (wrapper) wrapper.innerHTML = "";
    showLoader(true);
    currentPage = page;
    let filters = {
      action: "tdea_filter_formalities_callback",
      nonce: tdea_ajax.nonce,
      s: searchInput ? searchInput.value.trim() : "",
      user_type: userSelect ? userSelect.value : "",
      formality_type: typeSelect ? typeSelect.value : "",
      paged: page,
    };
    fetch(tdea_ajax.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: new URLSearchParams(filters).toString(),
    })
      .then((res) => res.json())
      .then((data) => {
        if (wrapper)
          if (wrapper) {
            if (
              data.html &&
              data.html.trim() !== "" &&
              !data.html.includes("No formalities found")
            ) {
              wrapper.innerHTML = data.html;
            } else {
              wrapper.innerHTML = "";
              let noResults = document.querySelector(
                ".full-programs__no-results"
              );
              if (!noResults) {
                noResults = createNoResultsContainer();
                wrapper.appendChild(noResults);
              }
              noResults.style.display = "block";
            }
          }
        if (paginationWrapper)
          paginationWrapper.innerHTML = data.pagination || "";
      })
      .finally(() => showLoader(false));
  }

  let clearBtn = null;
  if (searchInput) {
    clearBtn = document.createElement("span");
    clearBtn.innerHTML = "&times;";
    clearBtn.className = "clear-search-btn";
    clearBtn.style.display = "none";
    clearBtn.style.position = "absolute";
    clearBtn.style.right = "16px";
    clearBtn.style.top = "50%";
    clearBtn.style.transform = "translateY(-50%)";
    clearBtn.style.cursor = "pointer";
    clearBtn.style.fontSize = "1.15em";
    clearBtn.style.color = "#bbb";
    clearBtn.title = "Limpiar búsqueda";
    const label = searchInput.parentElement;
    if (label && window.getComputedStyle(label).position === "static") {
      label.style.position = "relative";
    }
    label.appendChild(clearBtn);

    function toggleClearBtn() {
      clearBtn.style.display = searchInput.value.length > 1 ? "block" : "none";
    }

    searchInput.addEventListener("input", function (e) {
      if (searchInput.value.length > 8) {
        triggerFilter(1);
      }
      toggleClearBtn();
      toggleClearAllBtn();
    });
    searchInput.addEventListener("keyup", function (e) {
      if (e.key === "Enter" && searchInput.value.length > 0) {
        triggerFilter(1);
      }
      toggleClearBtn();
      toggleClearAllBtn();
    });
    searchInput.addEventListener("focus", toggleClearBtn);
    clearBtn.addEventListener("click", function () {
      searchInput.value = "";
      toggleClearBtn();
      toggleClearAllBtn();
      triggerFilter(1);
      searchInput.focus();
    });
  }

  let clearAllBtn = document.createElement("span");
  clearAllBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 7H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M6 7V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`;
  clearAllBtn.className = "full-formalities__reset-button";
  clearAllBtn.style.display = "none";
  clearAllBtn.style.marginLeft = "18px";
  clearAllBtn.style.cursor = "pointer";
  clearAllBtn.style.fontSize = "1em";
  clearAllBtn.title = "Limpiar todos los filtros";
  const filtersBox = document.querySelector(".filter-formalities__inputs");
  if (filtersBox) {
    filtersBox.parentNode.insertBefore(clearAllBtn, filtersBox.nextSibling);
  }

  function toggleClearAllBtn() {
    const anyActive =
      (searchInput && searchInput.value.length > 0) ||
      (userSelect && userSelect.value) ||
      (typeSelect && typeSelect.value);
    clearAllBtn.style.display = anyActive ? "inline-block" : "none";
  }

  if (userSelect)
    userSelect.addEventListener("change", () => {
      triggerFilter(1);
      toggleClearAllBtn();
    });
  if (typeSelect)
    typeSelect.addEventListener("change", () => {
      triggerFilter(1);
      toggleClearAllBtn();
    });

  clearAllBtn.addEventListener("click", function () {
    if (searchInput) searchInput.value = "";
    if (userSelect) userSelect.selectedIndex = 0;
    if (typeSelect) typeSelect.selectedIndex = 0;
    if (clearBtn) clearBtn.style.display = "none";
    toggleClearAllBtn();
    triggerFilter(1);
  });

  if (paginationWrapper) {
    paginationWrapper.addEventListener("click", function (e) {
      if (e.target.classList.contains("full-formalities__page-btn")) {
        let page = parseInt(e.target.dataset.page, 10);
        if (!isNaN(page)) triggerFilter(page);
      }
    });
  }
});
